import { Context } from '@nuxt/types'

export default class ApiModuleBase {
  public $ctx: Context

  constructor(ctx: Context) {
    this.$ctx = ctx
  }
}
